import React from "react"
import UsersForm from "./form"

const defaultValues = {
  name: "",
  email: "",
  role_id: "",
}

const CreateUsers = ({ HeaderComponent = null }) => {
  return (
    <React.Fragment>
      <UsersForm
        defaultValues={defaultValues}
        HeaderComponent={HeaderComponent}
      />
    </React.Fragment>
  )
}

export default CreateUsers
